export default "__VITE_ASSET__d2872c38__"